import { Component } from '../../helpers/compiler';
import { direction, DragScroll } from './index';

@Component({ className: 'js-drag-scroll' })
export class DragScrollComponent {
	constructor(private element: HTMLElement) {
		const attr = (<any>direction)[this.element.getAttribute('data-drag-scroll-direction') as keyof typeof direction];
		new DragScroll(element, { direction: attr || direction.both });
	}
}